import axios from "axios";

// Sort direction values accepted by the customer list endpoint.
export const dataOrderAs = {
  ASC: "ASC",
  DESC: "DESC",
};

export const getCustomerList = (
  orderBy = "UserId",
  orderAs = dataOrderAs.DESC,
  pageNo = "",
  pageSize = ""
) => {
  let params = { orderBy: orderBy, orderAs: orderAs };

  if (pageNo !== "") {
    params = { ...params, pageNo: pageNo };
  }
  if (pageSize !== "") {
    params = { ...params, pageSize: pageSize };
  }

  return axios
    .get("/ruc/v3/customer", { params: params })
    .then((response) => response.data)
    .catch(function (error) {
      throw error;
    });
};

export const getUserDetail = (userId) => {
  return axios
    .get("/ruc/v3/customer/" + userId)
    .then((response) => response.data)
    .catch(function (error) {
      throw error;
    });
};

export const getUserRoles = () => {
  return axios
    .get("/ruc/v3/customer/roles")
    .then((response) => response.data)
    .catch(function (error) {
      throw error;
    });
};

export const getUserRoleList = (pageNo = "", pageSize = "") => {
  let params = {};

  if (pageNo !== "") {
    params = { ...params, pageNo: pageNo };
  }
  if (pageSize !== "") {
    params = { ...params, pageSize: pageSize };
  }

  return axios
    .get("/ruc/v3/customer/rolelist", { params: params })
    .then((response) => response.data)
    .catch(function (error) {
      throw error;
    });
};

export const createUserRole = (newRole) => {
  return axios
    .post("/ruc/v3/customer/roles", newRole)
    .then((response) => response.data)
    .catch(function (error) {
      throw error;
    });
};

export const updateUserRole = (roleId, updateRole) => {
  return axios
    .put("/ruc/v3/customer/roles/" + roleId, updateRole)
    .then((response) => response.data)
    .catch(function (error) {
      throw error;
    });
};

export const getUserRolePermission = (roleId) => {
  return axios
    .get("/ruc/v3/customer/roles/" + roleId + "/permissions/")
    .then((response) => response.data)
    .catch(function (error) {
      throw error;
    });
};

export const updateUserRolePermission = (roleId, permissions) => {
  return axios
    .put("/ruc/v3/customer/roles/" + roleId + "/permissions/", permissions)
    .then((response) => response.data)
    .catch(function (error) {
      throw error;
    });
};

export const deleteUserRole = (roleId) => {
  return axios
    .delete("/ruc/v3/customer/roles/" + roleId)
    .then((response) => response.data)
    .catch(function (error) {
      throw error;
    });
};

export const CreateCustomer = (customer) => {
  return axios
    .post("/ruc/v3/customer", customer)
    .then((response) => response.data)
    .catch(function (error) {
      throw error;
    });
};

export const UpdateCustomer = (userId, customer) => {
  return axios
    .put("/ruc/v3/customer/" + userId, customer)
    .then((response) => response.data)
    .catch(function (error) {
      throw error;
    });
};

export const UpdatePassword = (userId, customer) => {
  return axios
    .put("/ruc/v3/customer/" + userId + "/password", customer)
    .then((response) => response.data)
    .catch(function (error) {
      throw error;
    });
};
